export const SELFIE_ROOM_BOOKING_LEAD_SESSION_METADATA_KEY = "selfieroomBookingLeadSessionId";

export const getSelfieRoomBookingLeadSessionId = () => {
  if (typeof window === "undefined") return "";
  try {
    return window.sessionStorage.getItem(SELFIE_ROOM_BOOKING_LEAD_SESSION_METADATA_KEY) || "";
  } catch {
    return "";
  }
};
